import React from 'react';
import CccDashboardHeader from '../components/Dashboard/CccDashboardHeader';
import CccClientsWorkedFilters from '../components/Dashboard/CccClientsWorkedFilters';
import CccProposalRequestsFilters from '../components/Dashboard/CccProposalRequestsFilters';
import CccClientsWorkedSection from '../components/Dashboard/sections/CccClientsWorkedSection';
import CccProposalEstatisticasSection from '../components/Dashboard/sections/CccProposalEstatisticasSection';
import { useCccDashboardFilters } from '../components/Dashboard/useCccDashboardFilters';
import '../styles/cccDashboard.css';

const CccDashboardPage: React.FC = () => {
  const {
    filters,
    effectiveDateRange,
    effectiveRequestsDateRange,
    setTimeFilter,
    setCustomDateRange,
    setRequestsDateRange,
    setSelectedWorkspaces,
    setSelectedUsers,
    setSelectedStatuses,
    resetFilters,
  } = useCccDashboardFilters();

  return (
    <div className="dashboard-container ccc-dashboard-container">
      <CccDashboardHeader />
      <CccClientsWorkedFilters
        filters={filters}
        onTimeFilterChange={setTimeFilter}
        onCustomDateRangeChange={setCustomDateRange}
        onWorkspacesChange={setSelectedWorkspaces}
        onUsersChange={setSelectedUsers}
        onStatusesChange={setSelectedStatuses}
        onReset={resetFilters}
      />
      <div className="dashboard-content ccc-monitor-content">
        <CccClientsWorkedSection filters={filters} dateRange={effectiveDateRange} />
        <CccProposalRequestsFilters
          filters={filters}
          onRequestsDateRangeChange={setRequestsDateRange}
        />
        <CccProposalEstatisticasSection
          filters={filters}
          fromDate={effectiveRequestsDateRange[0]}
          toDate={effectiveRequestsDateRange[1]}
        />
      </div>
    </div>
  );
};

export default CccDashboardPage;
